import { type SxProps } from '@mui/material';

export const getLogoStyles = (showExpandedContent: boolean): SxProps => ({
  cursor: 'pointer',
  height: '20px',
  mt: 5,
  pl: showExpandedContent ? 2 : 1.25, // Center the icon when collapsed
  transition: 'all 0.2s ease-in-out',
});

// Keep the old export for backward compatibility if needed
export const LogoStyles: SxProps = {
  cursor: 'pointer',
  height: '20px',
  mt: 5,
  pl: 2,
};
